<template lang="pug">
  .form
    .form__elem
      .form-elem.form-elem_horizontal
        .form-elem__title Фамилия
        .form-elem__main
          .input {{lastName}}
    .form__elem
      .form-elem.form-elem_horizontal
        .form-elem__title Имя
        .form-elem__main
          .input {{firstName}}
    .form__elem
      .form-elem.form-elem_horizontal
        .form-elem__title Отчество
        .form-elem__main
          .input {{fathersName}}
    .form__elem.form__elem_short
      .form-elem.form-elem_horizontal
        .form-elem__title Пол
        .form-elem__main
          .input {{localGender}}
    .form__elem.form__elem_short
      .form-elem.form-elem_horizontal
        .form-elem__title Дата рождения
        .form-elem__main
          .input {{localDateOfBirth}}
    .form__elem
      .form-elem.form-elem_horizontal
        .form-elem__title Место рождения
        .form-elem__main
          .input {{placeOfBirth}}
    .form__elem(
      v-if="isAccompanying"
    )
      .form-elem.form-elem_horizontal
        .form-elem__title Сопровождающий
        .form-elem__main
          label.checkbox
            input(
            v-model="isAccompanying"
            type="checkbox"
            disabled="true"
            )
            .checkbox__text
    .form__elem
      .form-elem.form-elem_horizontal
        .form-elem__title Район
        .form-elem__main
          select.select(
            @change="setChange"
          )
            option(
              selected="selected"
              value="area.id"
            ) {{ area.name }}
            option(
              v-for="area_ in areas"
              :value="area_.id"
            ) {{area_.name}}
    .form__elem
      .form-elem.form-elem_horizontal
        .form-elem__main
          .button.action-panel__button(
            @click="saveUserProfile"
          ) Сохранить
</template>

<script>
import DatePicker from "vue2-datepicker";
import {mapActions} from "vuex";

export default {
  name: "request-general-info",
  components: {
    DatePicker,
  },
  props: {
    userId:{
      type: String,
      default: ''
    },
    area: {
      type: Object,
      default: () => ({
        name: "",
        id: "",
      }),
    },
    lastName: {
      type: String,
      default: "",
    },
    firstName: {
      type: String,
      default: "",
    },
    fathersName: {
      type: String,
      default: "",
    },
    gender: {
      type: [Boolean, Object, String],
      default: null,
    },
    dateOfBirth: {
      type: [String, Object],
      default: null,
    },
    placeOfBirth: {
      type: [String, Object],
      default: null,
    },
    isAccompanying: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localGender() {
      if (this.gender) {
        return "Мужской";
      } else {
        return "Женский";
      }
    },
    localDateOfBirth() {
      let date = null;
      date = this.dateOfBirth.split("-");
      date = date.reverse();
      date = date.join(".");
      return date;
    },
  },
  data() {
    return {
      areas: [],
      change_area: null,
    };
  },
  methods: {
    ...mapActions(["getAreas","changeUserProfile"]),
    setChange(val) {
      this.change_area = val.target.value;
    },
    saveUserProfile(){
      if(this.change_area){
        this.changeUserProfile({
          id: this.userId,
          area_id: this.change_area
        }).then(() => {
          debugger;
          this.$router.push('/administrator/requests')
        });
      }

    }
  },
  mounted() {
    this.getAreas().then((res) => {
      this.areas = res;
    });
  },
};
</script>
